import { resourceAccommodationZodObject } from "@@/shared/acquire/resources/resource-accommodation/resource-accommodation";
import { resourceTableGroupZodObject } from "@@/shared/acquire/resources/resource-table-group";
import { assertTypeMatch } from "@@/utilities/type-helpers";
import type { IsEqual } from "type-fest";
import { z } from "zod";
import { resourceGenericZodObject } from "./resource-generic";
import { resourceGroupZodObject } from "./resource-group";
import { resourceReservedZodObject } from "./resource-reserved";
import { resourceTableZodObject } from "./resource-table";

const resourceGlobalZodUnion = z.union([
    resourceGenericZodObject,
    resourceTableZodObject,
    resourceGroupZodObject,
    resourceTableGroupZodObject,
    resourceReservedZodObject,
    resourceAccommodationZodObject,
]);

type ResourceGlobal = z.infer<typeof resourceGlobalZodUnion>;
type ResourceGlobalType = ResourceGlobal["_type"];

const resourceGlobalTypes = [
    "RESOURCE_GENERIC",
    "RESOURCE_TABLE",
    "RESOURCE_GROUP",
    "RESOURCE_ACCOMMODATION",
    "RESOURCE_RESERVED",
    "RESOURCE_TABLE_GROUP",
] as const;

// make sure we've got all type types
// covered in the array
assertTypeMatch<
    IsEqual<ResourceGlobalType, (typeof resourceGlobalTypes)[number]>
>();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isResourceGlobal = (item: any): item is ResourceGlobal => {
    return (
        !!item &&
        typeof item?._type === "string" &&
        resourceGlobalTypes.includes(item._type)
    );
};

export { isResourceGlobal, resourceGlobalTypes, resourceGlobalZodUnion };
export type { ResourceGlobal, ResourceGlobalType };
